<template>
    <div class="manufacturer-hero container-fluid" :class="manufacturer.name.toLowerCase().replace(' ', '_') + '-bg'">
        <div class="row">
            <div class="col-sm-6 d-none d-sm-block text-center" :style="manufacturerBackgroundImage"></div>
            <div class="col-12 col-sm-6 p-5 position-relative">
                <img class="shadow img-fluid manufacturer-logo" :src="logoExists ? this.baseUrl + manufacturer.logo_image : brandImagePath + 'generic.png'" :alt="manufacturer.name + ' logo'" />
                <h1 class="mt-5 mb-4 ps-sm-5">{{ manufacturer.heading ? manufacturer.heading : manufacturer.name }}</h1>
                <div v-html="manufacturer.content" class="fw-light ps-sm-5"></div>
            </div>
        </div>
    </div>
    <div class="container main-content">
        <slimline-reg-size-form :postcode="postcode" :options="options" :image-base-path="tyreImagePath"></slimline-reg-size-form>
        <br class="clear"/>
        <p class="py-2" v-if="manufacturer.secondary_content" v-html="manufacturer.secondary_content"></p>
        <h2 class="my-4">{{ manufacturer.name }} OEM tyre brands</h2>
        <hr class="hr-navy">
        <div class="brand-content" v-if="manufacturerBrands.length > 0">
            <div class="row">
                <div class="col-6 col-sm-4 col-md-3 col-xxl-2" v-for="brand, key in manufacturerBrands" :key="key">
                    <a :href="this.baseUrl + '/' + brand.slug" :title="brand.name">
                        <img class="brand-image img-fluid mb-3" :src="brandImagePath + (brand.brand_image != null ? brand.brand_image : 'generic.png')" :alt="brand.name + ' logo'" />
                    </a>
                </div>
            </div>
        </div>
        <br class="clear"/>
        <div v-if="carRanges.length > 0" class="models">
            <div class="row">
                <div class="col-12">
                    <h2 class="h3 mt-2">Most popular {{ manufacturer.name }} Models</h2>
                    <hr class="hr-navy">
                </div>
                <div class="col-12 col-md-6 col-lg-3 mb-3" v-for="model, key in carRanges" :key="key">
                    <div class="card p-3">
                        <img :src="(tyreImagePath + (model.range_image != null ? model.range_image : 'Cars/template-car.png'))" :alt="manufacturer.name + ' ' + model.range_name" />
                        <h4 class="d-block text-center my-2">{{ manufacturer.name }} {{ model.range_name }}</h4>
                        <a class="btn btn-primary" :href="this.baseUrl + '/manufacturers/' + manufacturer.slug + '/' + model.range_slug" :title="model.range_name">
                            View all tyres
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <br class="clear"/>
    </div>
</template>

<script>
    export default {
        props: [
            'manufacturer',
            'manufacturerBrands',
            'options',
            'banners',
            'webName',
            'postcode',
            'carRanges',
            'brandImagePath',
            'tyreImagePath',
            'homeDeliverySession',
            'mostPopularRanges',
            'logoExists'
        ],
        mounted() {
			//removes loading placeholder - fixes CLS issues
            if (document.contains(document.querySelector('#loadingPlaceholder'))) {
			    document.querySelector('#loadingPlaceholder').style.display = 'none';
            }
        },
        computed: {
            manufacturerBackgroundImage() {
                let manufacturer_image = ('Backgrounds/etyres/Manufacturers/' + (this.manufacturer.slug) + '.jpg');
                return 'background: url(' + (this.tyreImagePath + manufacturer_image) + ') no-repeat; background-size: cover; height: 427px; background-position-y: 50%;';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .manufacturer-hero {
        background: #e9ecef !important;
        p, span {
            background-color: inherit !important;
        }
        .hero-img {
            max-width: 75%;
        }
    }
    .brand-image {
        max-width: 170px;
    }
    .title-text {
        @media screen and (min-width: 1200px) {
            max-width: 450px;
        }
    }
    .manufacturer-logo {
        background-color: #fff;
        @media screen and (min-width: 576px) {
            max-width: 150px;
            position: absolute;
            left: -85px;
            top: 80px;
        }
    }
    .main-content {
        .slimline {
            @media screen and (min-width: 992px) {
                margin-top: -35px !important;
            }
            position: relative;
        }
    }
    .models {
        .card {
            img {
                max-width: 75%;
                margin: 10px auto;
                max-height: 130px;
            }
        }
    }
</style>